const mEditionAcademyData = {
  mEditionAcademyData: {
    alerts: {
      updateAcademiaDatosPersona: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los datos de academia fueron actualizados exitosamente.'
      }
    },

    fieldsets: {
      steps: {
        first: '1. Información de Ubicación',
        second: '2. Información Legal',
        third: '3. Información de Contacto'
      }
    },

    inputs: {
      cod_postal: {
        label: 'Código Postal',
        message: '* De 1 a 10 caracteres'
      },

      documento_numero: {
        label: 'Número de Documento',
        message: '* De 3 a 30 caracteres'
      },

      documento_tipo: {
        label: 'Tipo de Documento',
        message: '* Primero debes seleccionar un país'
      },

      fisica: {
        label: 'Tipo de Persona'
      },

      linea1: {
        label: 'Dirección Principal',
        message: '* De 1 a 120 caracteres'
      },

      linea2: {
        label: 'Dirección Opcional'
      },

      localidad: {
        label: 'Localidad',
        placeholder: 'localidad'
      },

      movil: {
        label: 'Número de Móvil'
      },

      pais: {
        label: 'País'
      },

      provincia: {
        label: 'Provincia',
        message: '* Primero debes seleccionar un país'
      },

      razon_social: {
        labelBusiness: 'Razón Social',
        labelName: 'Nombre',
        message: '* De 3 a 150 caracteres',
        placeholder: 'Mi nombre'
      },

      telefono: {
        label: 'Número de Teléfono'
      }
    },

    validation: {
      cod_postal: {
        maxLength: 'La longitud máxima permitida es de 10 caracteres.',
        minLength: 'La longitud mínima permitida es de 1 caracteres.',
        required: 'Código Postal es requerido.'
      },

      documento_numero: {
        maxLength: 'La longitud máxima permitida es de 30 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Número de Documento es requerido. De 3 a 30 caracteres.'
      },

      documento_tipo: {
        required: 'Tipo de Documento es requerido. Primero debes seleccionar un país.'
      },

      fisica: {
        required: 'Tipo de Persona es requerido.'
      },

      linea1: {
        maxLength: 'La longitud máxima permitida es de 120 caracteres.',
        minLength: 'La longitud mínima permitida es de 1 caracteres.',
        required: 'Primera línea de dirección es requerida.'
      },

      movil: {
        required: 'Número de Móvil es requerido.'
      },

      pais: {
        required: 'País es requerido.'
      },

      provincia: {
        required: 'Provincia es requerida. Primero debes seleccionar un país.'
      },

      razon_social: {
        maxLength: 'La longitud máxima permitida es de 150 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Dato requerido. De 3 a 150 caracteres.'
      },

      telefono: {
        required: 'Número de Teléfono es requerido.'
      }
    }
  }
}
export default mEditionAcademyData
